import { Box, Paper, Typography } from "@mui/material";

/**
 * Shown to non-super-admin users when a super-admin enables maintenance mode
 * via the Admin Panel. Super-admins bypass this and see the normal app.
 */
export default function MaintenancePage() {
  return (
    <Box sx={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      bgcolor: "#F7F7FB",
      p: 3,
    }}>
      <Paper
        elevation={0}
        sx={{
          maxWidth: 480,
          width: "100%",
          p: { xs: 4, sm: 6 },
          borderRadius: 3,
          textAlign: "center",
          border: "1px solid",
          borderColor: "rgba(17,24,39,0.06)",
          bgcolor: "#FFFFFF",
        }}
      >
        <Box
          component="img"
          src="https://cdn.prod.website-files.com/68248960d18b6e3243218ec2/6859aa56110bd2ce54950f2c_mavi%20logo.svg"
          alt="MAVI"
          sx={{ height: 52, mb: 4 }}
        />
        <Typography sx={{ fontSize: 24, fontWeight: 800, color: "#111827", mb: 1.5 }}>
          Website Under Maintenance
        </Typography>
        <Typography sx={{ fontSize: 14, color: "text.secondary", lineHeight: 1.6 }}>
          We are currently undergoing scheduled maintanence, we'll be back shortly.
        </Typography>
      </Paper>
    </Box>
  );
}
